module.exports = "images/enfants.07da70df.png";